// Internal dependencies
const {
    // generateBorderAttributes,
    generateResBoxControlAttributes,
    generateResRangeAttributes,
    // generateAlignmentAttributes,
    generateTypographyAttributes,
    generateBorderAttributes
    // generateResBtnAttributes
} = window.faqmateModules;

// constants
import { G_MARGIN, ICON_WIDTH, ICON_HEIGHT, G_TYPO, C_BORDER, C_BRADIUS } from './constants';

const attributes = {
    sourceType: {
        type: 'string',
        default: 'library'
    },
    icon: {
        type: 'string',
        default: 'arrow-right'
    },

    aff_labelColors: {
        type: 'object',
        default: {
            normal: '',
            hover: ''
        }
    },
    iconColor: {
        type: 'strign'
    },
    //glaobal section
    ...generateTypographyAttributes({
        controlName: G_TYPO
    }),
    ...generateResBoxControlAttributes({
        controlName: G_MARGIN
    }),
    ...generateResRangeAttributes({
        controlName: ICON_WIDTH
    }),
    ...generateResRangeAttributes({
        controlName: ICON_HEIGHT
    }),
    ...generateBorderAttributes({
        controlName: C_BORDER
    }),
    ...generateResBoxControlAttributes({
        controlName: C_BRADIUS
    })
};

export default attributes;
